// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import { SpanWithData } from '../'

import { AmountDetail } from './AmountDetail'


export const CreditAmountAppliedFor = ({ amountAppliedFor, creditType, changeAmountAppliedFor, changeFailedFields=[], changeSuccessFields=[], readOnly }) => (
  <div className='slds-p-top_small slds-p-bottom_small slds-p-left_medium slds-m-bottom_medium' style={{ backgroundColor: '#f5f5f5'}}>
    <div className='u-font-size-larger slds-m-bottom_small'>
      <b>Loan amount applied for</b>
    </div>
    <AmountDetail
      label={<SpanWithData forField='CreditCreditType' searchKey={creditType} />}
      value={amountAppliedFor}
      onChange={changeAmountAppliedFor}
      readOnly={readOnly}
    />
  </div>
)

CreditAmountAppliedFor.propTypes = {
  amountAppliedFor: PropTypes.string,
  creditType: PropTypes.string.isRequired,
  changeFailedFields: PropTypes.array,
  readOnly: PropTypes.bool
}

CreditAmountAppliedFor.defaultProps = {
  amountAppliedFor: ''
}



// WEBPACK FOOTER //
// ./src/components/creditapplication-info/CreditAmountAppliedFor.js